//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { red, blue, eggShell } from '@fc/angie-ui/dist/styles/_js_exports.scss';

import AboveTheFold from '~/components/trackers/AboveTheFold.vue';
import SplitViewSections from '~/components/trackers/SplitViewSections.vue';
import Banner from '@/shared/components/Banner.vue';
import SplitTextView from '~/components/SplitTextView.vue';
import { metaData } from '~/configuration/metaData';

export default {
  name: 'Trackers',
  head: {
    ...metaData.trackersLanding,
  },
  components: {
    AboveTheFold,
    SplitTextView,
    SplitViewSections,
    Banner,
  },
  computed: {
    ctaInformation() {
      return {
        text: 'Explore Packages',
        url: '/shop',
      };
    },
    splitTextData() {
      return [
        {
          position: 'left', bgColor: red, textColor: eggShell, copy: 'More Motivation',
        },
        {
          position: 'right', bgColor: blue, textColor: red, copy: 'Better Experience',
        },
      ];
    },
  },
};
